// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"430":"79f242a5","716":"63308906"}[chunkId] + ".chunk.js";
};